// extracted by mini-css-extract-plugin
export default {"form":"User_form__pWyiE","button":"User_button__zU5fu","error":"User_error__uJvtW"};